import React, { useEffect, useCallback, useState, useRef } from 'react'; // Added useRef
import { connect } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';
import * as config from "../../assets/js/constant.js";
import { useImmer } from 'use-immer';
import useRazorpay from "react-razorpay";
import axios from 'axios';
import {
  Box, Button, Container, Divider, Grid, Step,
  StepContent, StepLabel, Stepper, Typography, CircularProgress
} from '@mui/material';
import '../MyDonationComponent/MyDonationComponent.css';

import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import MakeMyDonationComponent from '../MakeMyDonationComponent/MakeMyDonationComponent';
import ConfirmMyDonationComponent from '../ConfirmMyDonationComponent/ConfirmMyDonationComponent';
import FooterComponent from '../../common/FooterComponent/FooterComponent';
import BottomAppBarComponent from '../../common/BottomAppBarComponent/BottomAppBarComponent';
import {
  getDonationdetails,
  setDonationbookingDetails,
  setDonationPaymentDetails,
  donationPaymentProcess,
  donationComplete
} from '../../store/actions/donation.js';

const MyDonationComponent = ({
  donationPaymentProcess,
  getDonationdetails,
  donationDetails,
  setDonationbookingDetails,
  donationBookingDetails,
}) => {

  const reloadRazorpayScript = () => {
  return new Promise((resolve) => {
    const existing = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = resolve;
    document.body.appendChild(script);
  });
};

  const navigate = useNavigate();
  const { DonationID } = useParams();
  const [Razorpay] = useRazorpay();

  // --- SAFETY NET LOGIC START ---
  const orderIdRef = useRef(null); // Sticky note for Order ID

  const triggerMailOnClose = useCallback(() => {
    if (orderIdRef.current) {
      // Send the OrderID to the shared helper if user closes the tab
      const url = config.API_BASE_URL + `apiCall.php?apicall=triggerMailOnClose&OrderID=${orderIdRef.current}`;
      navigator.sendBeacon(url);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", triggerMailOnClose);
    return () => {
      window.removeEventListener("beforeunload", triggerMailOnClose);
    };
  }, [triggerMailOnClose]);
  // --- SAFETY NET LOGIC END ---

  const [isFetching, setIsFetching] = useState(true);
  const [getloader, setloader] = useImmer(false);
  const [activeStep, setActiveStep] = useImmer(0);

  useEffect(() => {
    if (DonationID) {
      setIsFetching(true);
      getDonationdetails(DonationID);
    }
  }, [DonationID, getDonationdetails]);

  useEffect(() => {
    if (!donationDetails) return;
    if (donationDetails.DonationID && Number(donationDetails.DonationID) === Number(DonationID)) {
      setIsFetching(false);
    } else if (Object.keys(donationDetails).length === 0) {
      const timer = setTimeout(() => {
        if (Object.keys(donationDetails).length === 0) {
          navigate("/make-a-donation");
        }
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [donationDetails, DonationID, navigate]);

  const DONATIONDETAILSVALUE = {
    entity: { value: "DONATION" },
    donationID: { value: "" },
    donationName: { value: "" },
    Amount: { value: "", isValid: false, errorMesssage: "Please enter Donation Amount" },
    donationUserName: { value: "", isValid: false, errorMessage: "User name not valid!!" },
    donationUserContact: { value: "", isValid: false, errorMessage: "User Contactnumber not valid!!" },
    donationUserAlt: { value: "", isValid: true, errorMessage: "User Alternatenumber not valid!!" },
    donationemailAddress: { value: "", isValid: true, errorMessage: "Email address not valid!!" },
    donationemailPincode: { value: "", isValid: true, errorMessage: "Email Pincode not valid!!" },
    userComments: { value: "", isValid: true, errorMessage: "Comments should not exceed 120 characters." },
    userPanNo: { value: "", isValid: true, errorMessage: "Please enter valid Pan Number." },
    userEmail: { value: "", isValid: true, errorMessage: "Please enter valid email." }
  };

  const [getuserDonationdetails, setuserDonationdetails] = useImmer(DONATIONDETAILSVALUE);

  useEffect(() => {
    if (donationDetails?.DonationID && String(donationDetails.DonationID) === String(DonationID)) {
      setuserDonationdetails((draft) => {
        draft.donationID.value = donationDetails.DonationID;
        draft.donationName.value = donationDetails.DonationName;
        draft.Amount.value = donationDetails.Amount || "";
      });
    }
  }, [donationDetails, DonationID, setuserDonationdetails]);

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handlePayment = useCallback((details) => {
    setloader(true);

    axios.post(config.API_BASE_URL + 'apiCall.php?apicall=donationOrderCreation', { data: details })
      .then(async response => {          // <-- added async
        const data = response.data.Data;
        const orderId = data.OrderID;
        orderIdRef.current = orderId;

        await reloadRazorpayScript();     // <-- new line: force a fresh Razorpay script

        const options = {
          key: data.key_id,
          amount: data.Amount,
          currency: data.Currency || "INR",
          name: "NSR Trust",
          order_id: orderId,
          handler: (res) => {
            orderIdRef.current = null;
            donationPaymentProcess(res);
            navigate("/donation-success", { state: { userEmail: details.userEmail } });
            setloader(false);
          },
          prefill: {
            name: details.pujaUserName,
            contact: details.pujaUserContact,
            email: details.userEmail
          },
          theme: { color: "#3399cc" },
          modal: { ondismiss: () => setloader(false) }
        };

        const rzpay = new window.Razorpay(options);
        rzpay.open();
        setloader(false);
      })
      .catch(() => setloader(false));
  }, [donationPaymentProcess, navigate, setloader]);

  const steps = [
    {
      label: 'Make A Donation',
      MakeDonation: <MakeMyDonationComponent getuserDonationdetails={getuserDonationdetails} setuserDonationdetails={setuserDonationdetails} />,
      nextStep: function () {
        // Validation for alternate number
        const contact = getuserDonationdetails.donationUserContact.value;
        const alt = getuserDonationdetails.donationUserAlt.value;
        const altLen = alt.length;

        // If alternate number is filled, must be exactly 10 digits and not same as contact
        if (
          (altLen > 0 && altLen !== 10) ||
          (altLen === 10 && contact === alt)
        ) {
          // Do not proceed to next step
          return;
        }

        // Add pincode validation here
        if (
          !getuserDonationdetails.donationemailPincode.isValid
        ) {
          // Do not proceed if pincode is invalid
          return;
        }

        if (
          getuserDonationdetails.Amount.isValid &&
          getuserDonationdetails.donationUserName.isValid &&
          getuserDonationdetails.donationUserContact.isValid &&
          getuserDonationdetails.donationUserAlt.isValid &&
          getuserDonationdetails.donationemailAddress.isValid &&
          getuserDonationdetails.donationemailPincode.isValid &&
          getuserDonationdetails.userComments.isValid &&
          getuserDonationdetails.userPanNo.isValid &&
          getuserDonationdetails.userEmail.isValid
        ) {
          const valuesOnly = Object.keys(getuserDonationdetails).reduce((acc, key) => {
            acc[key] = getuserDonationdetails[key].value;
            return acc;
          }, {});

          setDonationbookingDetails(valuesOnly);
          handleNext();
        }
      },
      buttons: ['Next']
    },
    {
      label: 'Confirmation',
      DonationConfirmation: <ConfirmMyDonationComponent />,
      nextStep: function () {
        setloader(true);
        handlePayment(donationBookingDetails);
      },
      buttons: ['Back', 'PayNow']
    }
  ];

  const renderButtons = (step) => {
    return step.buttons.map((button, index) => {
      let onClickAction = step.nextStep;
      if (button === 'Back') onClickAction = handleBack;

      return (
        <Button
          sx={{ mt: 1, mr: 1, ...(button === 'Back' && { color: 'grey', borderColor: 'grey !important' }) }}
          variant={button === 'Back' ? "outlined" : "contained"}
          key={index}
          onClick={onClickAction}
        >
          {button === 'PayNow' ? 'Pay Now' : button}
        </Button>
      );
    });
  };

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <HeaderComponent />
      <Box sx={{ mt: 3 }}>
        <Container>
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={12} md={5}>
              <Box className="user-selected-donation" sx={{ backgroundColor: '#ffffff', textAlign: 'center', py: 1, px: 1, borderRadius: '4px' }}>
                <img className='donation-image' src={config.image + donationDetails.Image} alt="donationImage" />
              </Box>
            </Grid>
            <Grid item xs={12} md={7}>
              <Box>
                <Typography sx={{ fontSize: '20px', fontWeight: '600', color: '#3875BF', mb: 2 }}>{donationDetails.DonationName}</Typography>
                <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 2.3, color: '#8E8E8E' }}>{donationDetails.Description}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider />
        </Container>
      </Box>
      <Box className="make-donation-screen">
        <Container>
          <Box sx={{ py: 2 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <Box className="stepper-label">
                    <StepLabel>{step.label}</StepLabel>
                  </Box>
                  <StepContent>
                    {step.MakeDonation}
                    {step.DonationConfirmation}
                    <Box className="stepContent-btn" sx={{ mb: 2, textAlign: 'right' }}>
                      {getloader ? <CircularProgress size={24} /> : renderButtons(step)}
                    </Box>
                    <Divider />
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Container>
        <FooterComponent />
      </Box>
      <BottomAppBarComponent />
    </>
  );
};

const mapStateToProps = (state) => ({
  donationDetails: state.donation.donationDetails,
  donationBookingDetails: state.donation.donationBookingDetails
});

export default connect(mapStateToProps, {
  donationPaymentProcess,
  getDonationdetails,
  setDonationbookingDetails,
  setDonationPaymentDetails,
  donationComplete
})(MyDonationComponent);